import { Theme, alpha, darken, lighten } from "@mui/material";

export const useStyles = (theme: Theme, isModeLight: boolean) => ({
  stackView: (isDown: boolean, entangled?: boolean, isCompact = false) => ({
    background: isModeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    padding: isCompact ? "2px 6px" : "4px 8px",
    display: "flex",
    flexDirection: isCompact ? "row" : "column",
    alignItems: "center",
    justifyContent: "center",
    gap: isCompact ? 0.5 : 0.3,
    borderRadius: isCompact ? 4 : 1,
    fontSize: 11,
    fontWeight: 600,
    opacity: entangled ? 1 : 0.33,
    zIndex: 1000,
    border: `1px solid ${isDown ? theme.palette.error.main : theme.palette.divider}`,
    animation: isDown ? "pulseBorda 2s infinite ease-in-out" : "none",
    "@keyframes pulseBorda": {
      "0%": {
        boxShadow: `0 0 10px 0px ${isCompact ? theme.palette.error.main : alpha(theme.palette.error.main, 0.7)}`,
      },
    },
  }),
  stackSimpleView: (isDown: boolean, entangled?: boolean) => ({
    background: isModeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    padding: "4px 8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    borderRadius: 1,
    fontSize: 11,
    fontWeight: 600,
    opacity: entangled ? 1 : 0.33,
    zIndex: 1000,
    border: `1px solid ${isDown ? theme.palette.error.main : theme.palette.divider}`,
    animation: isDown ? "pulseBorda 2s infinite ease-in-out" : "none",
    "@keyframes pulseBorda": {
      "0%": {
        boxShadow: `0 0 10px 0px ${alpha(theme.palette.error.main, 0.7)}`,
      },
    },
  }),
  clickableBaseEdge: (
    selected: boolean | undefined,
    editMode: boolean,
    colors: string,
    edgeOpacity: number,
    larguraLinha: number,
    animation: string,
    isDown: boolean,
    easyMapsConfig: any,
  ) => {
    const isSolid = editMode || animation === "desativada" || isDown;

    const dash = larguraLinha;
    const gap = animation === "pontilhada" ? larguraLinha * 2 : larguraLinha;
    const period = dash + gap;
    const marchingOn =
      !isSolid && easyMapsConfig?.configuracoes?.animacao?.linha !== false;
    return {
      stroke: selected
        ? (theme.palette as any).color.zabbixSeverty.selectedTranslucid
        : editMode
          ? "#5e5e5e"
          : colors,
      opacity: edgeOpacity,
      strokeWidth: larguraLinha,
      ...(editMode && { strokeLinecap: "round" as any }),
      ...(isSolid ? {} : { "--dash-period": `${period}px` }),
      animation: marchingOn
        ? `dashdrawEnlace ${period / 40}s linear infinite`
        : "none",
      // animation:
      //   easyMapsConfig?.configuracoes?.animacao?.linha !== false
      //     ? undefined
      //     : "none",
      strokeDasharray: isSolid ? "0" : `${dash},${gap}`,
      // strokeDasharray:
      //   editMode || animation === "desativada" || isDown
      //     ? "0"
      //     : animation === "pontilhada"
      //       ? "3,8"
      //       : "5",
    };
  },
  divEdge: (active: number, x: number, y: number) => ({
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute" as any,
    fontSize: 12,
    pointerEvents: "all" as any,
    width: active === 1 ? "1200px" : "20px",
    height: active === 1 ? "1200px" : "20px",
    transform: `translate(-50%, -50%) translate(${x}px,${y}px)`,
  }),
  buttonDraggable: (active: number) => ({
    width: "20px",
    height: "20px",
    fontSize: "14px",
    borderRadius: "50%",
    cursor: "pointer",
    lineHeight: 4,
    padding: 0,
    background: (theme.palette as any).color.zabbixSeverty.selectedTranslucid,
    border: active === 1 ? "1px solid #FFFFFF" : "1px solid #33333300",
  }),
  statusContainer: (theme: Theme) => ({
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1,
    color: theme.palette.error.main,
  }),
  statusText: (scale: number) => ({
    fontSize: `${10 * scale}px`,
    fontWeight: 700,
  }),
  layerRow: () => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
  }),
  metricContainer: () => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "2px",
  }),
  interfaceLabel: (theme: Theme, scale: number) => ({
    color: theme.palette.text.primary,
    fontSize: `${13 * scale}px`,
    fontWeight: 700,
    marginRight: "4px",
  }),
  metricValue: (theme: Theme, scale: number) => ({
    fontSize: `${14 * scale}px`,
    fontWeight: 600,
    color: theme.palette.text.primary,
  }),
  metricUnit: (theme: Theme, scale: number) => ({
    color: isModeLight
      ? darken(theme.palette.text.disabled, 0.3)
      : theme.palette.text.disabled,
    fontSize: `${12 * scale}px`,
    fontWeight: 600,
    marginLeft: "1px",
  }),
  divider: (scale: number) => ({
    borderWidth: `${1 * (scale || 1)}px`,
    height: `${14 * (scale || 1)}px`,
    borderColor: isModeLight
      ? darken(theme.palette.background.card, 0.7)
      : lighten(theme.palette.background.card, 0.7),
  }),
  compactValue: (color?: any, scale?: number) => ({
    fontSize: `${14 * (scale || 1)}px`,
    fontWeight: 600,
    color: color,
  }),
});
